import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import Notes from '../../components/FeedingGuidelines/Notes/Notes';
import fetchFeedingGuidelinesNotesAction from './../../store/actions/fetch/fetchFeedingGuidelinesNotesAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesNotesAction';

import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';

class FeedingGuidelinesNotes extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-notes'); 
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-notes'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const {data, pending, ready, error, notes} = this.props;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}>
        <Notes
          data={data}
          notes={notes}/>
      </OnImagesLoaded>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesNotesReducer.data,
    pending: state.feedingGuidelinesNotesReducer.pending,
    ready: state.feedingGuidelinesNotesReducer.ready,
    error: state.feedingGuidelinesNotesReducer.error,
    notes: state.feedingGuidelinesGenerateReducer.notes,
    screenshots: state.pdfOutputReducer.images,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesNotesAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-notes',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesNotes);
